import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";

export const ProgressBarContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${DesignConstants.SPACES.L};
`;

export const ProgressBarTrack = styled.div`
    width: 100%;
    height: ${DesignConstants.SPACES.XS};
    background-color: ${DesignConstants.COLORS.WHITE};
    border: ${DesignConstants.BORDERS.THIN} ${DesignConstants.COLORS.P6_SUCCESS_400};
    border-radius: 1000px;
`;

export const ProgressBarFill = styled.div<{ progress: number }>`
    height: 100%;
    background-color: ${DesignConstants.COLORS.P6_SUCCESS_400};
    transition: width 0.3s ease;
    width: ${(props) => props.progress}%;
`;

export const ProgressPercentage = styled.div`
    color: ${DesignConstants.COLORS.P6_SUCCESS_500};
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
    font-size: ${DesignConstants.FONT_SIZES.XL};
`;
